import { Toast } from "vant";
import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import { setCxid } from "../utils/cxid";
import { getQuery } from "../utils/url";

Vue.use(VueRouter);

const routes = [
  {
    path: "/index",
    name: "index",
    component: () => import("../views/index.vue"),
  },
  {
    path: "/setting",
    name: "setting",
    component: () => import("../views/setting.vue"),
  },
  {
    path: "*",
    redirect: () => {
      return {
        name: "index",
      };
    },
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  console.log("tototo", to);
  let cxid = getQuery("cxid");

  /**缓存渠道码 */
  if (cxid) {
    setCxid(cxid);
  }

  if (!store.state.userInfo.uuid) {
    Toast.loading({
      message: "加载中",
      duration: 0,
    });

    await store.dispatch("initStore");

    Toast.clear();
  }

  next();
});

export default router;
